import React, { useState, useEffect } from 'react';

import { db, storage } from '../FireBase'; // Import Firestore and Storage instances
import { collection, addDoc, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import { Container, Tab, Tabs } from 'react-bootstrap';
import SliderImageControl from '../components/SliderImageControl';
import UserSettings from '../components/UserSettings';
import ContactSettings from '../components/contactSettings';
import UpdateNoticeAdmin from '../components/updateNoticeSettings';
// import ShippingCharges from '../components/ShippingCharges';
// import TagFilterSliderControl from '../components/TagSliderControl';


const SettingsPage = () => {
   const [key, setKey] = useState('sliderimagecontrol'); // Default tab

  return (
      <Container fluid  className='inventory-page'>
      <br/>
      <h1>Settings</h1>
      <br/>
      <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
      >
          <Tab eventKey="sliderimagecontrol" title="Slider image settings">
            <SliderImageControl/>
            
          </Tab>
          <Tab eventKey="categories" title="Users settings">
            <UserSettings/>
             
          </Tab>
          <Tab eventKey="contactsettings" title="Contact Settings">
              <ContactSettings />
          </Tab>
           <Tab eventKey="updatenotice" title="Update Notice Settings">
              <UpdateNoticeAdmin />
          </Tab>
          
          
         
      </Tabs>
      </Container>
  );
};

export default SettingsPage;